import React from 'react';
import Auth from '../general/auth.js';
import moment from 'moment';
import momentDurationPlugin from 'moment-duration-format';

export default class Test extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            authenticated: false,
            loaded: false,
            currentQuestion: 0,
            test: {}
        }
    }
    componentDidMount()
    {
        this.checkAuth();
    }
    checkAuth()
    {

        new Auth().checkAuth(this.props.api, (result) => {
            this.setState({authenticated: true});
            this.getCourseTest();
        }, (err) => {
            console.dir(err);
        });
    }
    getCourseTest()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Test",
            action: "GetTest",
            method: "post",
            body: JSON.stringify({courseID: this.props.courseID, testID: this.props.testID}),
            success: (result) => {
                if (result.success)
                {
                    var firstunfinishedquestion = 0;
                    result.test.courseTestQuestions.forEach((q, i) => {
                        if (q.myAnswers.length > 0)
                            firstunfinishedquestion = i + 1 === result.test.courseTestQuestions.length ? i : i + 1;
                    })
                    this.setState({
                        loaded: true, 
                        test: result.test,
                        currentQuestion: firstunfinishedquestion
                    }, () => {
                        setInterval(() => {
                            var test = this.state.test;
                            var questions = test.courseTestQuestions;
                            var question = questions[this.state.currentQuestion];
                            question.questionTime++;
                            this.setState({ test: test });
                        }, 1000)
                    })
                }
                else
                {
                    this.setState({loaded: true});
                }   
            },
            error: (err) => {
                this.setState({loaded: true});
            }

        })
    }
    prevClick()
    {
        const cq = this.state.currentQuestion;
        this.updateAttempt(false, () => {
            this.setState({currentQuestion: cq-1})
        });
    }
    nextClick()
    {
        const cq = this.state.currentQuestion;
        this.updateAttempt(false, () => {
            this.setState({currentQuestion: cq+1})    
        });
    }
    finishClick()
    {
        this.updateAttempt(true, () => {
            this.props.getAttempt();
        });
    }
    updateAttempt(complete, callback)
    {
        var test = this.state.test;
        var curquestion = test.courseTestQuestions[this.state.currentQuestion];
        var myAnswers = curquestion.myAnswers;
        this.props.api.send({
            controller: "Test",
            action: "UpdateAnswer",
            method: "post",
            debug: true,
            body: JSON.stringify({
                testQuestionID: curquestion.testQuestionID, 
                myAnswers: myAnswers, 
                questionTime: curquestion.questionTime,
                complete: complete
            }),
            success: (result) => {
                callback();
                console.dir(result);
            },
            error: (err) => {
                console.dir(err);
            }
        })
    }
    answerChanged(e)
    {
        var test = this.state.test;
        var questions = test.courseTestQuestions 
        var question = questions[this.state.currentQuestion];
        if (question.questionTypeID === 0)
        {
            question.myAnswers = [];
            question.myAnswers.push(parseInt(e.target.value, 10));
        }
        else
        {
            console.log(e.target.checked);
            if (e.target.checked)
            {
                question.myAnswers.push(parseInt(e.target.value, 10));
            }
            else
            {
                var idx = question.myAnswers.indexOf(parseInt(e.target.value, 10));
                question.myAnswers.splice(idx, 1);
            }
        }
        this.setState({test: test});
    }
    render()
    {
        const test = this.state.test;
        const question = test.courseTestQuestions && test.courseTestQuestions.length >= this.state.currentQuestion + 1 ?
            test.courseTestQuestions[this.state.currentQuestion] : null;

        // Check if all questions have at least one answer
        var showFinishButton = true;
        if (test.courseTestQuestions)
        {
            test.courseTestQuestions.forEach(q => {
                if (q.myAnswers.length === 0)
                    showFinishButton = false;
            });
        }
        const answers = question && question.answers ? question.answers.map((a) => {
            return (
                <div key={a.answerID}>
                    {question.questionTypeID === 0 ? (
                        <label className="lmsinputcontainer"> {a.answerText}
                            <input type="radio" name="answer" className="lmsradio" value={a.answerID} 
                                checked={question.myAnswers.indexOf(a.answerID) !== -1} 
                                onChange={(e) => this.answerChanged(e)} />
                            <span className="lmsradiocheck"></span><br />
                        </label>
                    ) : (
                        <label className="lmsinputcontainer"> {a.answerText}
                            <input type="checkbox" name="answer" className="lmscheckbox" value={a.answerID} 
                                checked={question.myAnswers.indexOf(a.answerID) !== -1} 
                                onChange={(e) => this.answerChanged(e)} /> 
                            <span className="lmscheckmark"></span>
                        </label>
                    )}
                </div>
            )
        }) : null;
        var time = question ? moment.duration(question.questionTime, 'seconds') : moment.duration(0, 'seconds');
        return (
            <div className="lmstest">
                {this.state.loaded ? 
                    this.state.authenticated ? (
                        <div>
                            <div className="lmsquestion">{question ? question.questionText : "An error occurred while loading test questions."}</div>
                            <div className="lmsanswers">
                                {answers}
                            </div>
                            <div className="lmstestfooter">
                                { this.state.currentQuestion > 0 ? (
                                    <input className="lmsbutton lmsquestionbutton lmsquestionprev" type="button" value="Previous" onClick={(e) => this.prevClick()} />
                                ) : null}
                                { this.state.currentQuestion + 1 < test.courseTestQuestions.length ? (
                                    <input className="lmsbutton lmsquestionbutton lmsquestionnext" type="button" value="Next" onClick={(e) => this.nextClick()} />
                                ) : null}
                                { showFinishButton ? (
                                    <input className="lmsbutton lmsquestionbutton lmsquestionfinish" type="button" value="Finish" onClick={(e) => this.finishClick()} />
                                ) : null}
                                <div className="lmstestinfo">
                                    Question {this.state.currentQuestion +1} of {test.courseTestQuestions ? test.courseTestQuestions.length : "Unkonwn"}
                                    <div className="lmsquestiontime">Time: {time.format("mm:ss", {trim: false})}</div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            You are not authenticated or do not have access to this course.  <a href="/" className="bodylink">Log in here.</a>
                        </div>
                    ) : (
                    <div className="lmscenter">
                        <img src="/images/spinner.svg" alt="Loading..."  className="spinnerbg" />
                    </div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/course/test.js